import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SapiService {

  env = environment;
  constructor(private readonly http: HttpClient) { }

  createSAPIVisitForSecurityQuestions(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/Sapi/SapiCreateVisitForSQ', data);
  }
createSAPIVisitForSecurityQuestionsWithToken(data: any, token: string): Observable<any> {
    return from(
      fetch(this.env.webApiUrl + 'api/Sapi/SapiCreateVisitForSQ', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(data)
      }).then(async (response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
    );
  }

  // Post-login binary (true/false) security questions - SAPI process 26.
  createSAPIVisitForBinarySecurityQuestions(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/Sapi/SapiCreateVisitForBinarySQ', data);
  }

  fetchBinaryEventFromSapi() {
    return this.http.get(this.env.webApiUrl + 'api/Sapi/FetchBinaryEventFromSapi');
  }

  postSapiSQVerification() {
    return this.http.post(this.env.webApiUrl + 'api/UserVerification/PostSapiSQVerification', null);
  }

  fetchEventFromSapi() {
    return this.http.get(this.env.webApiUrl + 'api/Sapi/FetchEventFromSapi');
  }

  binarySecurityQuestionFailed() {
    return this.http.post(this.env.webApiUrl + 'api/Sapi/BinarySecurityQuestionFailed', {});
  }
}
